import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MAT_SNACK_BAR_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { UserModel } from '@core/api/model/userModel';
import { TransportModel } from '@core/api/model/transportModel';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { OrderModel, TrailerModel, UserService } from '@core/api';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { OrderService } from '@accounts/user/services/order.service';
import { ActivatedRoute, Router } from '@angular/router';

export interface IComponentData {
  order: OrderModel;

}

@Component({
  selector: 'modal-rental-panel',
  templateUrl: './modal-rental-panel.component.html',
  styleUrls: ['./modal-rental-panel.component.scss']
})
export class ModalRentalPanelComponent {
  accepted: boolean;
  user: UserModel;
  order: OrderModel;
  trailer: TrailerModel
  constructor(
    private i18n: I18n,
    private orderService: OrderService,
    public dialog: MatDialog,
    private router: Router,

    @Inject(MAT_SNACK_BAR_DATA) public data: IComponentData
  ) {
    this.order = data.order;
    this.trailer = data.order.trailer;
  }

  get timeLeft(): string {
    return this.orderService.getTimeLeft(this.order);
  }

  showDetails() {
    this.router.navigate(['../cabinet/in-rent']);

  }

  get isPaidTimeOver(): boolean{
    return this.orderService.isPaidTimeOver(this.order);
  }
}
